// extracted by mini-css-extract-plugin
export default {"container":"ExpenseInfoSection_container__2XRso"};